import { rankingItems } from "@/mocks/home";
import Reveal from "./Reveal";

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[0.85fr_1.15fr] lg:gap-12">
          <Reveal>
            <span className="font-label text-xs tracking-[0.35em] text-primary-600">HOT LIST</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              内幕解析热榜
            </h2>
            <p className="mt-4 font-body text-sm leading-relaxed text-foreground-600">
              榜单按长图完读率与对照引用次数综合排序，每周更新一次。排在前面的，通常是被拆得最透的那几件。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              <span className="rounded-full bg-secondary-100 px-3 py-1 font-label text-xs text-secondary-900">
                完读率
              </span>
              <span className="rounded-full bg-accent-100 px-3 py-1 font-label text-xs text-accent-800">
                引用次数
              </span>
              <span className="rounded-full bg-primary-100 px-3 py-1 font-label text-xs text-primary-700">
                更新时间轴
              </span>
            </div>
            <a
              href="#download"
              className="mt-7 flex w-fit cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
            >
              <i className="ri-line-chart-line text-base" />
              查看完整拆解榜单
            </a>
          </Reveal>

          <div className="flex flex-col gap-3">
            {rankingItems.map((item, index) => (
              <Reveal key={item.rank} delay={index * 60}>
                <div className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-200 hover:bg-background-50 md:gap-6">
                  <span
                    className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-md font-heading text-lg font-bold ${
                      index === 0
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-200 text-foreground-800"
                    }`}
                  >
                    {item.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <span className="font-label text-[11px] text-foreground-400">{item.tag}</span>
                    </div>
                    <h3 className="mt-1 truncate font-heading text-base font-bold text-foreground-950">
                      {item.title}
                    </h3>
                    <div className="mt-2 flex items-center gap-3">
                      <span className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-300">
                        <span
                          className={`block h-full rounded-full ${
                            index === 0 ? "bg-primary-500" : "bg-accent-500"
                          }`}
                          style={{ width: `${item.heat}%` }}
                        />
                      </span>
                      <span className="w-10 shrink-0 text-right font-label text-xs text-foreground-500">
                        {item.heat}°
                      </span>
                    </div>
                  </div>
                  <i className="ri-arrow-right-line hidden shrink-0 text-foreground-400 transition-colors group-hover:text-primary-600 md:block" />
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}